import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend,
  ResponsiveContainer, CartesianGrid,
} from 'recharts';
import Skeleton from './Skeleton';
import { CHART_COLORS } from '../../../core/constants/financial';

const RevenueChart = ({ data = [], loading }) => (
  <div className="fd-panel">
    <div className="fd-panel-header">
      <h3 className="fd-panel-title">Receitas × Despesas — últimos 6 meses</h3>
    </div>
    {loading ? (
      <div className="fd-chart-skeleton">
        <Skeleton width="100%" height="100%" />
      </div>
    ) : (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} barGap={4} barSize={20}>
          <CartesianGrid strokeDasharray="3 3" stroke="#555" vertical={false} />
          <XAxis
            dataKey="mes"
            tick={{ fill: '#ccc', fontSize: 12 }}
            axisLine={{ stroke: '#555' }}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: '#ccc', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`}
          />
          <Tooltip
            contentStyle={{
              background: '#67676a',
              border: '1px solid #383838',
              borderRadius: 6,
              color: '#fff',
              fontSize: 12,
            }}
            formatter={(value) => `R$ ${value.toLocaleString('pt-BR')}`}
            labelStyle={{ color: '#ccc', fontWeight: 600 }}
          />
          <Legend
            iconType="square"
            wrapperStyle={{ fontSize: 12, color: '#ccc', paddingTop: 8 }}
          />
          <Bar dataKey="receitas" name="Receitas" fill={CHART_COLORS.green} radius={[3, 3, 0, 0]} />
          <Bar dataKey="despesas" name="Despesas" fill={CHART_COLORS.orange} opacity={0.8} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    )}
  </div>
);

export default RevenueChart;
